import { React, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import Hover from "../OnHoverDetails/Hover";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));

export function Layout18(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  const headerText = () => {
    return (
      <>
        {/* {showShimmer ? (
          <>
            <div className="line linehead linedesk" style={{ width: "190px", margin: "0" }} />
            <div className="line linehead linedesk" style={{ margin: "12px 0 0 0" }} />
          </>
        ) : (
          <>
              </>
        )} */}
        <div className="temp15-item-bay">
          <div className="temp15-itemColor">
            <h4>
              {props.Layout1.display_title}{" "}
              <span className="red">{props.Layout1.display_title_sufix}</span>{" "}
            </h4>
            <p>{props.Layout1.section_log_line}</p>
          </div>
        </div>
      </>

    );
  };

  let Closepopup = () => {
    setshowdetails(false);
  };
  return (
    <>
      <section className="mb-0 dD-none">
        <div className="temp15 temp15-mov">
          <div className="temp15-area">
            <Swiper
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              // loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                700: {
                  slidesPerView: 4.2,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[FreeMode, Pagination]}
              className="temp15-slider"
            >
              {props.Layout1.contents.map((data, index) => {
                var GenereTitle = data.genres.split(",");
                GenereTitle = GenereTitle[0];
                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                // if (index == 0) {
                //   return (
                //     <SwiperSlide key={index} className="temp15-item">
                //       {headerText()}
                //     </SwiperSlide>
                //   );
                // } else {
                return (
                  <>
                    {index == 0 ? (
                      <SwiperSlide key={index} className="temp15-item">
                        {headerText()}
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                    <SwiperSlide key={index} className="temp15-item">
                      {/* {showShimmer ? (
                        <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                      ) : (
                        <>
                        </>
                      )} */}
                      <div
                        className="temp15-itemColor"
                        onClick={() => {
                          showdetailspop(data);
                        }}
                      >
                        <img src={data.thumbnail_image2.small} alt="DocuBay" />
                        <div className="premium-red">
                          {premium}
                          {original}
                        </div>
                      </div>
                    </SwiperSlide>
                  </>
                );
                // }
              })}
              <SwiperSlide></SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section>
        <div className="temp15 temp15-mov mb-0 dD-block">
          <div className="temp15-area">
            {/* <div className="side-overlay-L dD-block"></div> */}
            <div className="side-overlay-R dD-block"></div>
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              slidesPerGroup={5}
              loop={false}
              // loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[FreeMode, Pagination, Navigation]}
              className="temp15-slider"
            >
              <button
                className="slick-prev slick-arrow"
                type="button"
                aria-label="Previous"
              />
              {props.Layout1.contents.map((data, index) => {
                var GenereTitle = data.genres.split(",");
                GenereTitle = GenereTitle[0];
                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                // if (index == 0) {
                // return (

                // )
                // } else {
                return (
                  <>
                    {index == 0 ? (
                      <SwiperSlide key={0} className="temp15-item">
                        {headerText()}
                      </SwiperSlide>
                    ) : (
                      ""
                    )}

                    <SwiperSlide key={index} className="temp15-item">
                      {/* {showShimmer ? (
                        <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                      ) : (
                        <>
                           </>
                      )} */}
                          <Hover
                            data={data}
                            silverIcon={props.silverIcon}
                            goldenIcon={props.goldenIcon}
                          />
                          <div className="temp15-itemColor">
                            <img src={data.thumbnail_image2.small} alt="DocuBay" />
                            <div className="premium-red1">
                              {premium}
                              {original}
                            </div>
                          </div>
                     
                    </SwiperSlide>
                  </>
                );
                // }
              })}
              <SwiperSlide></SwiperSlide>
              <button
                className="slick-next slick-arrow"
                type="button"
                aria-label="Next"
              />
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout18;
